/**
 * FBA费用计算Hook
 */

import { useState, useEffect } from 'react';
import { calculateFBAFee, calculateStorageFee, Site, ProductType } from '../../../utils/fbaFeeData';

export const useFBAFeeCalculation = (
    site: string,
    length: number,
    width: number,
    height: number,
    weight: number,
    price: number,
    productType: ProductType,
    isPeakSeason: boolean,
    hasLithiumBattery: boolean = false
) => {
    const [fbaFee, setFbaFee] = useState<number>(0);
    const [lithiumBatteryFee, setLithiumBatteryFee] = useState<number>(0);
    const [totalFbaFee, setTotalFbaFee] = useState<number>(0);
    const [storageFee, setStorageFee] = useState<{ jan_sep: number, oct_dec: number }>({ jan_sep: 0, oct_dec: 0 });
    const [fbaTierName, setFbaTierName] = useState<string>('');

    useEffect(() => {
        if (site && weight > 0) {
            const result = calculateFBAFee(
                site as Site,
                length,
                width,
                height,
                weight,
                price || 0,
                productType,
                isPeakSeason,
                hasLithiumBattery
            );

            if (result) {
                setFbaFee(result.fee);
                setLithiumBatteryFee(result.lithiumBatteryFee);
                setTotalFbaFee(result.totalFee);
                setFbaTierName(result.tierName + (result.isLowPrice ? ' (低价费率)' : ''));

                const storage = calculateStorageFee(
                    site as Site,
                    length,
                    width,
                    height,
                    result.tierName
                );
                setStorageFee(storage);
            } else {
                setFbaFee(0);
                setLithiumBatteryFee(0);
                setTotalFbaFee(0);
                setFbaTierName('未匹配到费率 (可能超限)');
                setStorageFee({ jan_sep: 0, oct_dec: 0 });
            }
        }
    }, [site, length, width, height, weight, price, productType, isPeakSeason, hasLithiumBattery]);

    const currentStorageFee = isPeakSeason ? storageFee.oct_dec : storageFee.jan_sep;

    return {
        fbaFee,
        setFbaFee,
        lithiumBatteryFee,
        totalFbaFee,
        storageFee,
        currentStorageFee,
        fbaTierName,
    };
};
